export const UPLOAD_TEST_CASE_MODAL_SUCCESS_DELAY = 2000;
